<template>
    <footer class="creditFooter" v-if="show">
        <img :src="require('@/assets/gomXchange.png')" alt="gomXchange logo" class="creditLogo">
        <div class="creditLinks"> 
            <!-- <a href=""> -->
                <img alt="" :src="require('@/assets/mrs_logo.png')" width="70" />
            <!-- </a> -->
        </div>
    </footer>
</template>

<script>
export default {
    props: [
        "enableNoBorder"
    ],
    data: () => ({
        show: true
    }),
    methods: {
        checkNoBorder: function() {
            var globv = this;
            if (globv.enableNoBorder && ![null, undefined].includes(globv.$route.query.noborder)) {
                globv.show = !globv.$route.query.noborder;
            }
            else {
                globv.show = true;
            }
        }
    },
    mounted: function() {
        var globv = this;
        globv.checkNoBorder();
    },
    watch: {
        '$route.query.noborder': function() {
            var globv = this;
            globv.checkNoBorder();
        }
    }
}
</script>

<style lang="scss" scoped>
.creditFooter {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color:#9e9e9e;
    background-color: var(--footerBackgroundColor);
    padding: 10px 5px;
}

.creditLinks {
  display: flex;
  align-items: center;

  a {
    padding: 5px 10px;
  }
}

.creditLogo {
    height: 3rem;
}

@media (max-width: 560px) {
    .creditFooter {
        flex-direction: column;
        align-items: center;
    }
}

@media (max-width: 290px) {
    .creditFooter .creditLinks {
        flex-direction: column;
    }
}
</style>